import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { BRAND, CONTACT } from "../data/site";
import SocialLinks from "./SocialLinks";

const rows = [
  { icon: Phone, label: "Phone", value: CONTACT.phoneDisplay, href: `tel:${CONTACT.phone}`, testid: "info-phone" },
  { icon: Mail, label: "Primary Email", value: CONTACT.email, href: `mailto:${CONTACT.email}`, testid: "info-email" },
  { icon: Mail, label: "Business Enquiries", value: CONTACT.businessEmail, href: `mailto:${CONTACT.businessEmail}`, testid: "info-business-email" },
  { icon: MapPin, label: "Address", value: CONTACT.address, href: null, testid: "info-address" },
  { icon: Clock, label: "Business Hours", value: CONTACT.hours, href: null, testid: "info-hours" },
];

export const ContactInfo = () => {
  return (
    <div className="glass rounded-3xl p-8 md:p-10 h-full">
      <h3 className="font-head text-2xl font-semibold text-white mb-1">Reach {BRAND.name} directly</h3>
      <p className="text-slate-400 text-sm mb-8">We respond within one business day.</p>
      <ul className="space-y-6">
        {rows.map((r) => {
          const Icon = r.icon;
          const content = (
            <div className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-xl bg-brand-orange/15 grid place-items-center shrink-0">
                <Icon size={20} className="text-brand-orange" />
              </span>
              <div className="min-w-0">
                <p className="font-mono text-xs tracking-wider uppercase text-slate-500">{r.label}</p>
                <p className="text-slate-200 mt-1 leading-relaxed break-words">{r.value}</p>
              </div>
            </div>
          );
          return (
            <li key={r.label}>
              {r.href ? (
                <a href={r.href} data-testid={r.testid} className="block group transition-colors [&_p:last-child]:group-hover:text-brand-orange">
                  {content}
                </a>
              ) : (
                <div data-testid={r.testid}>{content}</div>
              )}
            </li>
          );
        })}
      </ul>

      <div className="mt-8 pt-8 border-t border-white/10">
        <p className="font-mono text-xs tracking-wider uppercase text-slate-500 mb-4">Follow {BRAND.short}</p>
        <SocialLinks prefix="info" showLabels />
      </div>
    </div>
  );
};

export default ContactInfo;
